import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTranslation } from "i18n-fe";

// #3135 (the scoreadmin-fe half of #2792 AC6). A judge's elimination ends the
// ride for EVERY judge on it, but the elimination record lives only on that
// judge's own sheet. Without this, an admin looking at a sibling sheet (in
// RideEditor, or in its audit trail) sees an ordinary in-progress sheet with
// no hint why the ride ended. Neutral wording, same stance as scribe-fe's
// RideTerminatedAlertBanner: it states the ride-level fact and does not say
// which judge recorded it or judge that elimination.
//
// `reason` is score-common's deriveRideTermReason result (a TERM_REASONS
// value, e.g. "Eliminated" or "Scratched"). Null/empty renders nothing.
export default function RideTerminatedBanner({ reason, "data-testid": testId = "ride-terminated-banner" }) {
  const { t } = useTranslation("scoreadmin");
  if (!reason) return null;
  return (
    <Box
      data-testid={testId}
      role="status"
      sx={{
        mb: 2,
        p: 1.5,
        bgcolor: "background.paper",
        border: 1,
        borderColor: "error.main",
        borderRadius: 2,
      }}
    >
      <Typography
        data-testid={`${testId}-header`}
        variant="overline"
        sx={{ display: "block", mb: 0.5, fontWeight: 700, lineHeight: 1.2, color: "error.main" }}
      >
        {t("rideTerminatedBanner.header", { reason })}
      </Typography>
      <Typography variant="body2" color="text.primary">
        {t("rideTerminatedBanner.body")}
      </Typography>
    </Box>
  );
}
